// import bog from 'bog';

const REGEXP = /(nokia|iphone|android|motorola|^mot-|softbank|foma|docomo|kddi|up.browser|up.link|htc|dopod|blazer|netfront|helio|hosin|huawei|novarra|CoolPad|webos|techfaith|palmsource|blackberry|alcatel|amoi|ktouch|nexian|samsung|^sam-|s[cg]h|^lge|ericsson|philips|sagem|wellcom|bunjalloo|maui|symbian|smartphone|midp|wap|phone|windows ce|iemobile|^spice|^bird|^zte-|longcos|pantech|gionee|^sie-|portalmmm|jigs browser|hiptop|^benq|haier|^lct|operas*mobi|opera*mini|320x320|240x320|176x220)/i;
const USER_SET_DEVICE = 'userSetDevice';
const whiteList = ['/m-HomePage.html', '/m-register.html'];

const getUserAgent = (isServer, req) => {
  let userAgent = '';
  if (isServer) {
    userAgent = req.get('user-agent');
  } else {
    // eslint-disable-next-line prefer-destructuring
    userAgent = window.navigator.userAgent;
  }
  return userAgent;
};

const defaultRedirect = (isServer, req, res, targetPage, ref) => {
  const userAgent = getUserAgent(isServer, req);
  const userSetDevice = isServer ?
    req.cookies[USER_SET_DEVICE] : window.localStorage.getItem(USER_SET_DEVICE);
  if (!whiteList.includes(targetPage)) {
    return false;
  }

  if (userSetDevice === 'PC') return false;
  if (REGEXP.exec(userAgent)) {
    const redirectUrl = ref ? `${targetPage}?ref=${ref}` : targetPage;
    // if (!isServer) bog.info('Redirecting to mobile site.', targetPage);
    isServer ?
      res.redirect(redirectUrl) :
      window.location.href = redirectUrl;
    return true; // needed, returns from express middleware
  }
  return false;
};

export default defaultRedirect;

export function checkMobile(isServer, req) {
  const userAgent = getUserAgent(isServer, req);

  return REGEXP.test(userAgent);
}
